import moment from "moment";
// import $ from 'jquery';
import 'slick-slider/slick/slick.min'

// const x = moment.duration(120, "days").humanize();
// console.log(x);
$(".batches-total-card").click(function(){
  $("#book-demo-right").addClass("bt-shake");
});
$("#book-demo-right").hover(function(){
  $("#book-demo-right").removeClass("bt-shake");
})
$(document).ready(function(){
  let mediaBatch = window.matchMedia("(max-width: 600px)")
  let totalBatches = $('.batches-total-card').length;
  if(totalBatches>2){
    $(".batches-total-card").removeClass("mx-3");
    $(".batches-total-card").removeClass("col-4");
    $('#upcoming-slick').not('.slick-initialized').slick(
      {
        dots: false,
        infinite: true,
        speed: 300,
        padding:'20px',
        slidesToShow: 3,
        slidesToScroll: 3,
        autoplay: true,
        arrows : true,
        nextArrow: '<a><i class="fa fa-arrow-right" aria-hidden="true"></i></a>',
        prevArrow: '<a><i class="fa fa-arrow-left" aria-hidden="true"></i></a>',
        autoplaySpeed: 6000,
        responsive: [
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 3,
              infinite: true,
              dots: true
            }
          },
          {
            breakpoint: 600,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 2
            }
          },
          {
            breakpoint: 480,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1
            }
          }
        ]
      }
    )
  }
  if (mediaBatch.matches && totalBatches<=2) {
    $(".batches-total-card").removeClass("mx-3");
    $(".batches-total-card").removeClass("col-4");
    $('#upcoming-slick').not('.slick-initialized').slick(
      {
        dots: true,
        infinite: true,
        speed: 300,
        padding:'20px',
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        arrows : true,
        nextArrow: '<a><i class="fa fa-arrow-right" aria-hidden="true"></i></a>',
        prevArrow: '<a><i class="fa fa-arrow-left" aria-hidden="true"></i></a>',
        autoplaySpeed: 6000
      }
    )
  }

})

  var isLast = function (word) {
    return $(word).next().length > 0 ? false : true;
  }

  var getNext = function (word) {
    return $(word).next();
  }

  var getVisible = function () {
    return document.getElementsByClassName('course-visible');
  }

  var getFirst = function () {
    var node = $('.course-words-wrapper').children().first();
    return node;
  }

  var switchWords = function (current, next) {
    $(current).removeClass('course-visible').addClass('course-hidden');
    $(next).removeClass('course-hidden').addClass('course-visible');
  }

  var getStarted = function () {
    //We start by getting the visible element and its sibling
    var first = getVisible();
    var next = getNext(first);

    //If our element has a sibling, it's not the last of the list. We switch the classes
    if (next.length !== 0) {
      switchWords(first, next);
    } else {

      //The element is the last of the list. We remove the visible class of the current element
      $(first).removeClass('course-visible').addClass('course-hidden');

      //And we get the first element of the list, and we give it the visible class. And it starts again.
      var newEl = getFirst();
      $(newEl).removeClass('course-hidden').addClass('course-visible');
    }

  }

  var init = function () {
    setInterval(function () {
      getStarted()
    }, 2000);
  }

  init();

